import { z } from 'zod';

export const InternalNetworkCveRetestJobStatusSchema = z.enum([
  'PENDING',
  'RUNNING',
  'COMPLETED',
  'FAILED',
]);

export const TriggerInternalNetworkCveRetestBodySchema = z.object({
  cveIds: z.array(z.string().min(1)).max(50).optional(),
});

export const InternalNetworkCveRetestJobSchema = z.object({
  id: z.string(),
  networkId: z.string(),
  status: InternalNetworkCveRetestJobStatusSchema,
  cveIds: z.array(z.string()),
  newCveIds: z.array(z.string()),
  matchedHostCount: z.number(),
  errorMessage: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const InternalNetworkCveRetestJobListResponseSchema = z.object({
  data: z.array(InternalNetworkCveRetestJobSchema),
  total: z.number(),
});

export type InternalNetworkCveRetestJobDto = z.infer<
  typeof InternalNetworkCveRetestJobSchema
>;
export type TriggerInternalNetworkCveRetestBodyDto = z.infer<
  typeof TriggerInternalNetworkCveRetestBodySchema
>;
export type InternalNetworkCveRetestJobListResponseDto = z.infer<
  typeof InternalNetworkCveRetestJobListResponseSchema
>;
